import type { UIStringsOverride } from "../i18n-ui.ts";

/** Polish (pl) UI strings. */
export const pl: UIStringsOverride = {
  actions: {
    addToCursor: "Dodaj do Cursor",
    addToVscode: "Dodaj do VS Code",
    askAI: "Zapytaj AI o tę stronę",
    connectMcp: "Połącz z MCP",
    copied: "Skopiowano!",
    copyClaudeCode: "Kopiuj polecenie Claude Code",
    copyCode: "Kopiuj kod",
    copyCodex: "Kopiuj polecenie Codex",
    copyMarkdown: "Kopiuj jako Markdown",
    copyServerUrl: "Kopiuj adres URL serwera",
    edit: "Edytuj na GitHubie",
    export: "Eksportuj",
    exportEpub: "Eksportuj do EPUB",
    exportPdf: "Eksportuj do PDF",
    generating: "Generowanie…",
    openIn: "Otwórz w {name}",
    openInChat: "Otwórz w czacie",
    scrollToTop: "Wróć na górę",
  },
  ask: {
    ai: "AI",
    clear: "Wyczyść rozmowę",
    close: "Zamknij",
    copy: "Kopiuj rozmowę",
    empty: "Zadaj pytanie dotyczące dokumentacji.",
    error: "Przepraszamy, coś poszło nie tak.",
    label: "Zadaj pytanie",
    placeholder: "Zadaj pytanie…",
    send: "Wyślij",
    tip: "Wskazówka: czat możesz otwierać i zamykać za pomocą",
    title: "Zapytaj AI",
    you: "Ty",
  },
  banner: { dismiss: "Zamknij ogłoszenie" },
  changelog: {
    description: "Aktualizacje produktu i informacje o wydaniach.",
    showReleases: "Pokaż wydania {version}",
    title: "Dziennik zmian",
  },
  content: { diagramError: "Nie udało się wyświetlić tego diagramu." },
  feedback: {
    no: "Nie",
    question: "Czy ta strona była pomocna?",
    thanks: "Dziękujemy za opinię!",
    yes: "Tak",
  },
  languageSwitcher: { label: "Język", untranslated: "Nieprzetłumaczone" },
  nav: {
    back: "Wstecz",
    breadcrumb: "Ścieżka nawigacyjna",
    closeNavigation: "Zamknij nawigację",
    deprecated: "przestarzałe",
    featured: "Polecane",
    githubRepository: "Repozytorium GitHub",
    navigation: "Nawigacja",
    primary: "Główne",
    sections: "Sekcje",
    toggleNavigation: "Przełącz nawigację",
    toggleTheme: "Przełącz motyw kolorystyczny",
  },
  notFound: {
    description: "Nie znaleźliśmy strony, której szukasz.",
    home: "Wróć na stronę główną",
    title: "Nie znaleziono strony",
  },
  page: {
    lastUpdated: "Ostatnia aktualizacja",
    next: "Następny",
    pagination: "Paginacja",
    previous: "Poprzedni",
    skipToContent: "Przejdź do treści",
  },
  search: {
    all: "Wszystkie",
    allLanguages: "Wszystkie języki",
    askAi: "Zapytaj AI",
    askAiHint: "Uzyskaj natychmiastową odpowiedź od AI",
    button: "Szukaj",
    devOnly: "Wyszukiwanie jest dostępne w kompilacji produkcyjnej.",
    error: "Coś poszło nie tak. Spróbuj ponownie.",
    label: "Przeszukaj dokumentację",
    navigate: "nawigacja",
    noResults: "Nie znaleziono wyników.",
    open: "otwórz",
    placeholder: "Przeszukaj dokumentację…",
    popular: "Popularne",
    preview: "podgląd",
    results: "Wyniki",
  },
  toc: { title: "Na tej stronie" },
};
